var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CEBC",
    d: "M3.383 2.282c0-1.008.807-1.821 1.822-1.821a1.822 1.822 0 1 1-1.821 1.821m10.047 7.812h-3.305V7.14c0-1.439-1.257-2.602-2.672-2.602h-4.43C1.47 4.54.14 5.885.141 7.211v5.414c-.002.6.422.913.843.914.423 0 .844-.312.844-.914V7.352h.563v6.187h5.484V7.352h.563l.005 3.541c-.004.614.376.875.768.888h4.219c1.15 0 1.15-1.687 0-1.687m2.8-1.982v.543c0 .303.24.543.544.543.298 0 .543-.24.543-.543v-.543h.555V6.336a.84.84 0 0 0-.62-.811l-.63-1.513a.61.61 0 0 0-.566-.38h-3.253a.61.61 0 0 0-.566.38L11.6 5.525a.84.84 0 0 0-.619.811v1.776h.55v.543a.542.542 0 1 0 1.085 0v-.543zm-4.122-.976a.548.548 0 1 1-.001-1.096.548.548 0 0 1 .001 1.096m5.15-.548a.548.548 0 1 1-1.096 0 .548.548 0 0 1 1.097 0M12.15 5.496l.543-1.309a.17.17 0 0 1 .158-.11h3.153c.076 0 .14.046.164.11l.543 1.309z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCar);
export default __webpack_public_path__ + "static/media/userCar.1dfd3d83adb710eb775fa15233899386.svg";
export { ForwardRef as ReactComponent };